import { createApp, provide } from 'vue';
import { createPinia } from 'pinia';
import _ from 'lodash';
import GeneralPaymentApp from './vue/general-payment-app/app.vue';

function InitGeneralPayment(options) {
    const pinia = createPinia();
    const app = createApp(GeneralPaymentApp);
    app.use(pinia);
    _.forEach(options, (value, key) => app.provide(key, value));

    app.mount('#GeneralPaymentApp');
}

export { InitGeneralPayment }